/*
 * @Author: YuanYuan
 * @Date: 2024-02-07 11:04:36
 * @LastEditTime: 2024-02-07 11:06:53
 * @description: 账户总览路由定义
 */
import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'Bills',
  leftActiveIndex: '/account'
}

export default [
  {
    path: '/account',
    meta: {
      ...Meta,
      title: i18n.t('menu.accountOverview')
    },
    component: () => import('@/views/account/index.vue')
  },
  {
    path: '/account/recharge',
    meta: {
      ...Meta,
      title: i18n.t('orders.recharge'),
      backable: true
    },
    component: () => import('@/views/account/recharge.vue')
  }
]
